// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// We now use Environment Variables.
// In React, these must start with REACT_APP_
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    // This helps debug if you forgot to set them in Vercel later
    console.warn("Supabase keys are missing! Check your Environment Variables.");
}

// Revert to the original export pattern to resolve the initialization error.
// This declares, initializes, and exports the variable in a single atomic step.
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Add the debugging line *after* the export.
// This ensures 'supabase' is fully initialized before we assign it to the window.
if (process.env.NODE_ENV === 'development') {
    window.supabase = supabase;
}